import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LookupFieldComponent } from '../lookup-field/lookup-field.component';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { FieldBase, InputWithSuffixField } from '@nagel-types';

@Component({
    selector: 'lib-input-with-suffix-field',
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        LookupFieldComponent
    ],
    templateUrl: './input-with-suffix-field.component.html',
    styleUrl: './input-with-suffix-field.component.scss'
})
export class InputWithSuffixFieldComponent extends BaseFieldComponent {
    @Input() override field!: FieldBase<unknown>;
    @Input() override form!: FormGroup;

    get min(): number | undefined {
        return (this.field as InputWithSuffixField<unknown>).min;
    }

    getFloatLabelState(alwaysShow: boolean) {
        return alwaysShow ? 'always' : 'auto';
    }

    override isApplicable(fieldType: string) {
        return fieldType === 'input';
    }
}